import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { ar } from 'vuetify/locale'

const archiveTheme = {
  dark: false,
  colors: {
    primary: '#734F96',
    'primary-darken-1': '#5c3f78',
    'primary-lighten-1': '#8a66ab',
    secondary: '#9575CD',
    'secondary-darken-1': '#7E57C2',
    'secondary-lighten-1': '#B39DDB',
    accent: '#B388FF',
    error: '#D32F2F',
    info: '#7C4DFF',
    success: '#388E3C',
    warning: '#F57C00',
    background: '#F5F7FA',
    surface: '#FFFFFF',
  }
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'archiveTheme',
    themes: {
      archiveTheme,
    },
  },
  defaults: {
    global: {
      ripple: true,
    },
    VBtn: {
      variant: 'flat',
      rounded: 'lg',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
    },
    VCard: {
      rounded: 'xl',
      elevation: 2,
    },
  },
  locale: {
    locale: 'ar',
    fallback: 'ar',
    messages: { ar },
    rtl: {
      ar: true,
    },
  },
})
